import firebase from 'firebase/app'
import 'firebase/database'

const config = {
    apiKey: "AIzaSyB2hvtz1nGr1H6rlNosKNCrI9yfLUweK6o",
    authDomain: "novuss-firebase.firebaseapp.com",
    databaseURL: "https://novuss-firebase.firebaseio.com",
    projectId: "novuss-firebase",
    storageBucket: "novuss-firebase.appspot.com",
    messagingSenderId: "911408467283"
};

let app = firebase.initializeApp(config);
let db = app.database();

export default db;


// WEBPACK FOOTER //
// ./src/firebase.js